import { QueryKeysEnum } from '@/enums/queryKey';
import {
  EmailAlertEntity,
  EmailAlertParams,
  EmailAlertPayload,
} from '@/types/email-alert';
import APIService from './axios.service';
import { BaseService } from './base.service';

class AlertConfigService extends BaseService<'alertConfig', EmailAlertEntity> {
  constructor() {
    super(QueryKeysEnum.ALERT_CONFIG);
  }

  getAll = (params: EmailAlertParams): Promise<EmailAlertEntity[]> => {
    return APIService.get(this.path, { params });
  };

  updateAlertConfig = (
    payload: EmailAlertPayload,
  ): Promise<EmailAlertEntity> => {
    const { id, ...rest } = payload;

    return APIService.put(this.path + '/' + id, rest);
  };
}

export const alertConfigService = new AlertConfigService();
